import axios from 'axios';
import { ADMIN_NODE_URL, centcomURL, encryptStorage } from '../constant';
import { DASHBOARD_URL } from '../constant';
import { PerformanceURL as URL } from '../constant';
import { Leave_URL } from '../constant';
import { Directory_URL } from '../constant';
import { Todo_URL } from '../constant';
import { composeApi } from './api';

const decodeJwtToken = (token) => {
    try {
        // Split the token into its three parts: header, payload, and signature
        const [headerEncoded, payloadEncoded] = token.split('.');

        // Decode the base64-encoded payload
        const payload = JSON.parse(atob(payloadEncoded));
        return payload;
    } catch (error) {
        console.error('Error decoding JWT token:', error.message);
        return null;
    }
};

export function getSessionToken() {
    try {
        let token = encryptStorage.getItem('jwtToken');
        if (token == undefined) {
            window.location.href = '/';
        } else {
            // Replace with your actual JWT token
            let value = decodeJwtToken(token);
            if (encryptStorage.getItem('employeeId') == value?.empId) {
                return token;
            } else {
                window.location.href = '/';
            }
        }
    } catch (error) {
        throw error;
    }
}
export async function adminClient(body) {
    try {
        //debugger;
        let token;

        let groupId = encryptStorage.getItem('groupid');

        switch (body.methodname) {
            case 1: {
                token = '';

                break;
            }

            case 2: {
                token = '';

                break;
            }

            default: {
                token = getSessionToken();

                break;
            }
        }

        if (token != undefined && body.methodname == 8 && body.modulename == 1) groupId = 1;

        if ((token != undefined && groupId == 1) || body.modulename == 10) {
            //debugger;

            body['jwt'] = encryptStorage.getItem('jwtToken');
            body['emp_id'] = encryptStorage.getItem('employeeId');
            body['groupId'] = encryptStorage.getItem('groupid');
            // body = JSON.stringify(body);

            const dat = await composeApi(JSON.stringify(body));

            var config = {
                method: 'POST',

                url: ADMIN_NODE_URL,

                headers: {
                    'Content-Type': 'application/json',
                },
                data: dat,
            };

            const response = await axios(config);

            return response;
        }
    } catch (error) {
        throw error;
    }
}
export async function adminClient1(body) {
    try {
        //debugger;
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');
        // body = JSON.stringify(body);

        var config = {
            method: 'POST',

            url: ADMIN_NODE_URL,

            headers: {
                'Content-Type': 'application/json',
            },
            data: await composeApi(JSON.stringify(body)),
        };
        
        const response = await axios(config);

        return response;
    } catch (error) {
        throw error;
    }
}
/**
 * PC_PG_06, PC_PG_07, PC_PG_16,PC_PF_08,PC_PF_09,PC_TG_07,PC_TG_08,PC_PF_18,PC_AG_07,PC_AG_08,PC_AG_16,PC_AG_17,PC_AF_08,PC_AF_09,PC_AF_18
 *PC_AF_19,PC_AF_25,PC_AF_26,PC_TG_16,PC_TG_17,
 *  imported the axios package
 * with URL and body data API call is made
 */

export async function clientPerformance(body) {
    let token = getSessionToken();
    if (token !== undefined) {
        axios.defaults.headers.common = {
            'Content-Type': 'application/json',
            // 'authorization': 'Bearer '+ token
        };
        
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');
        const dat = await composeApi(JSON.stringify(body));
        var config = {
            method: 'post',
            url: URL,
            headers: {
                'Content-Type': 'application/json',
            },
            data: dat,
        };

        const response = await axios(config);

        return response;
    }
}

/**
 * PC_PG_06, PC_PG_07, PC_PG_16,PC_PF_08,PC_PF_09,PC_TG_07,PC_TG_08,PC_SR_29,PC_SR_30,PC_SR_31,PC_SR_32,PC_SR_33,PC_SR_34,PC_SR_35,PC_SR_36,PC_SR_37
 * imported the axios package
 * with URL and body data API call is made
 */

export async function CentcomClient(body) {
    let token = getSessionToken();
    if (token !== undefined) {
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');

        var config = {
            method: 'POST',
            url: centcomURL,
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer '+ token,
            },
            // data: composeApi(body),
            data: body,
        };

        let response = await axios(config);
        //
        return response;
    }
}

export async function DirectoryClient(body) {
    let token = getSessionToken();

    if (token !== undefined) {
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');

        const dat = await composeApi(JSON.stringify(body));
        var config = {
            method: 'post',
            url: Directory_URL,
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer '+ token,
            },
            data: dat,
        };

        let response = await axios(config);

        return response;
    }
}
/**
 * PC_TD_07,PC_TD_08,PC_TD_18,PC_TD_19,PC_TD_27,PC_TD_28,PC_TD_36,PC_TD_37,PC_FD_21
 * imported the axios package
 * with URL and body data API call is made
 */
export async function DirectoryClient2(formData) {
    let token = getSessionToken();

    if (token !== undefined) {
        formData['jwt'] = encryptStorage.getItem('jwtToken');
        formData['emp_id'] = encryptStorage.getItem('employeeId');
        formData['groupId'] = encryptStorage.getItem('groupid');

        const config = {
            method: 'post',
            url: Directory_URL,
            headers: {
               'Content-Type': 'application/json',
                // 'route': 'true'  
            },
            data: formData,
        };

        try {
            const response = await axios(config);
            return response;
        } catch (error) {
            console.error("Error in DirectoryClient2:", error);
            throw error;
        }
    } else {
        throw new Error("Token is undefined");
    }
}

export async function dashboardClient(body) {
    let token = getSessionToken();
    if (token !== undefined) {
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');
        const dat = await composeApi(JSON.stringify(body));
        const config = {
            method: 'POST',
            url: DASHBOARD_URL,
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': 'Bearer '+ token,
            },
            data: dat,
        };
        let response = await axios(config);

        //
        if (response.data.body) {
            response.data.body = response.data.body;
        }
        response.data = response.data;

        return response;
    }
}

/**
 * PC_OF_13
 * imported the axios package
 * with URL and body data API call is made
 */
export async function clientOff(body) {
    let token = getSessionToken();
    if (token !== undefined) {


        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');

        const data = await composeApi(JSON.stringify(body));
        const config = {
            method: 'POST',
            url: Leave_URL,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        };

        const response = await axios(config);
        return response;
    }
}

export async function clientWfh(body) {
    let token = getSessionToken();
    if (token !== undefined) {
        // body['jwt'] = encryptStorage.getItem('jwtToken');
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');

        const data = await composeApi(JSON.stringify(body))

        const config = {
            method: 'POST',
            url: Leave_URL,
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer '+ token,
            },
            data
        };

        const response = await axios(config);

        return response.data;
    }
}
/** PC_PD_1.10 to  PC_PD_14, PC_PD_32 to PC_PD_34
 * imported the axios package
 * with URL and body data API call is made
 */
export async function todo_client(body) {
    let token = getSessionToken();
    if (token !== undefined) {
        body['jwt'] = encryptStorage.getItem('jwtToken');
        body['emp_id'] = encryptStorage.getItem('employeeId');
        body['groupId'] = encryptStorage.getItem('groupid');

        const data = await composeApi(JSON.stringify(body))

        var config = {
            method: 'post',
            url: Todo_URL,
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer '+ token
            },
            data
        };

        let resp = [];

        let response = await axios(config);

        if (Array.isArray(response.data)) {
            response.data.forEach((element, index) => {
                resp.push(element);
            });
        } else {
            resp = response.data;
        }

        // let morris = (resp.body);
        //

        return resp;
    }
}

export const clientService = async (method, url, { params = {}, ...payload } = {}) => {
    let token = getSessionToken(); // Retrieve the JWT token from session storage
    let empId = encryptStorage.getItem('employeeId'); // Retrieve employee ID
    let groupId = encryptStorage.getItem('groupid'); // Retrieve group ID
    
    try {
        // Prepare the payload to include empId and groupId
        const dataPayload = {
            ...payload,
            employee_id: empId, // Include employee ID
            group_id: groupId // Include group ID
        };

        const dat = await composeApi(JSON.stringify(dataPayload));
        const requestConfigurations = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Authorization': token ? `Bearer ${token}` : undefined // Include the JWT token if it exists
            },
            params: params,  // This will handle query parameters
            data: dat || dataPayload // Use the prepared payload
        };

        const response = await axios(requestConfigurations);
        return response;
    } catch (error) {
        console.error("Error in clientService:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const clientService1 = async (method, url, { params = {}, ...payload } = {}) => {
    let token = getSessionToken(); // Retrieve the JWT token from session storage
    let empId = encryptStorage.getItem('employeeId'); // Retrieve employee ID
    let groupId = encryptStorage.getItem('groupid'); // Retrieve group ID
    
    try {
        // Prepare the payload to include empId and groupId
        const dataPayload = {
            ...payload,
            employee_id: empId, // Include employee ID
            group_id: groupId // Include group ID
        };

        const requestConfigurations = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Authorization': token ? `Bearer ${token}` : undefined // Include the JWT token if it exists
            },
            params: params,  // This will handle query parameters
            data: dataPayload // Use the prepared payload
        };

        const response = await axios(requestConfigurations);
        return response;
    } catch (error) {
        console.error("Error in clientService:", error.response ? error.response.data : error.message);
        throw error;
    }
};